import { IconButton, Stack, TableCell, TableRow } from "@mui/material"
import { Bound } from "lib/@components/binding/Bound"
import { BlockClicks } from "lib/@components/block-clicks"
import { ContextMenuBar } from "lib/@components/context-menu-bar"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import Iconify from "minimals-template/components/Iconify"
import { SelectItemCheckbox } from "./lib/select-item-checkbox"
import { useDemand } from "lib/authorization/use-demand"
import { AUTHORING_EDIT_SCHEDULES_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"

export function ReferenceRow({ reference }) {
    const { legacyId, title, redirectUrl } = reference
    const canEditSchedule = useDemand(AUTHORING_EDIT_SCHEDULES_DEMAND)
    const selectionCheckbox = canEditSchedule ? <SelectItemCheckbox /> : null
    const contextMenu = canEditSchedule ? <ContextMenuBar type="reference" /> : null
    return (
        <Bound reference={reference} selectedId={legacyId}>
            <TableRow hover data-cy="reference-row">
                <TableCell sx={{ width: 70, maxWidth: 70, whiteSpace: "noWrap", p: 0 }}>{selectionCheckbox}</TableCell>
                <TableCell sx={{ whiteSpace: "noWrap", px: 0, maxWidth: { xs: 150, md: 350 } }}>
                    <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
                        <BlockClicks>
                            <IconButton
                                aria-label="Open legislation"
                                onClick={() => window.open(redirectUrl, "legislation")}
                                data-cy="open-legislation-url"
                            >
                                <Iconify icon="majesticons:open-line" sx={{ color: "primary.main" }} />
                            </IconButton>
                        </BlockClicks>
                        <TruncatedTypography>{title}</TruncatedTypography>
                    </Stack>
                </TableCell>
                <TableCell sx={{ width: 70, maxWidth: 70, whiteSpace: "noWrap", py: 0 }}>{contextMenu}</TableCell>
            </TableRow>
        </Bound>
    )
}
